import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import NoEntriesMessage from "../../../../components/common/NoEntriesMessage/NoEntriesMessage";
import SingleClientReportForm from "../../components/single-client/form";
import {
  getSingleClientReportEntries,
  getSingleClientReportEntriesCount,
  setSingleClientReportEntriesCurrentPage,
  setSingleClientReportEntriesSearchFilters,
  clearSingleClientReportEntries,
  setItemsPerPageSingleClientReport,
} from "../../actions";

import {
  singleClientReportPageInfoSelector,
  singleClientReportEntriesSelector,
  singleClientReportIsLoadingSelector,
  singleClientReportNoEntriesMessageSelector,
} from "../../selectors";
import SingleClientReportEntriesTable from "../../components/single-client/form/table";

import "./singleClientReportPage.css";
import Pagination from "../../../../components/Pagination/Pagination";
import { PageTitle } from "../../../../components/common";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";
import { trimFormData } from "../../../../utilities/filters";
import { organizationInfoSelector } from "../../../organization/selectors";
import { mainClientTypeSelector } from "../../../../selectors/getScoreCardByTypeSelectors";

const SingleClientReportPage = () => {
  const singleClientReportEntries = useSelector(
    singleClientReportEntriesSelector
  );
  const isLoading = useSelector(singleClientReportIsLoadingSelector);
  const { count, itemsPerPage, currentPage } = useSelector(
    singleClientReportPageInfoSelector
  );
  const [isSubmitted, setIsSubmitted] = useState(false);
  const clientTypes = useSelector(mainClientTypeSelector);
  const [isOpenCollapse, setIsOpenCollapse] = useState(true);
  const noEntriesMessage = useSelector(
    singleClientReportNoEntriesMessageSelector
  );
  const organizationInfo = useSelector(organizationInfoSelector);

  const toggleCollapse = () => setIsOpenCollapse(!isOpenCollapse);

  const dispatch = useDispatch();

  useEffect(() => {
    if (count > 0 && isSubmitted) {
      dispatch(getSingleClientReportEntries({ take: itemsPerPage }));
      setIsSubmitted(false);
    }
  }, [count]);

  useEffect(() => {
    return () => {
      dispatch(clearSingleClientReportEntries());
    };
  }, []);

  const handleSubmit = (data) => {
    if (!isOpenCollapse) {
      return;
    }
    const trimmedData = trimFormData(data);
    dispatch(setSingleClientReportEntriesSearchFilters(trimmedData));
    dispatch(getSingleClientReportEntriesCount(trimmedData));
    setIsSubmitted(true);
    setIsOpenCollapse(false);
  };

  const onPageChange = (_, page) => {
    dispatch(setSingleClientReportEntriesCurrentPage(page + 1));
    const skip = page * itemsPerPage;
    dispatch(getSingleClientReportEntries({ take: itemsPerPage, skip }));
  };

  const onRowsPerPageChange = ({ target }) => {
    dispatch(setSingleClientReportEntriesCurrentPage(1));
    dispatch(setItemsPerPageSingleClientReport(target.value));
    dispatch(getSingleClientReportEntries({ take: target.value, skip: 0 }));
  };

  return (
    <Container
      className="single-client-report-entries-page-container col-12 p-0"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          document
            .getElementById("searchMonitoringQueueEntriesSubmitButton")
            .click();
        }
      }}
    >
      <PageTitle title="single client report" />
      <FullscreenLoader loading={isLoading} />

      {!singleClientReportEntries.length ? (
        <div className="single-client-report-background-logo" />
      ) : null}
      <SingleClientReportForm
        isOpenCollapse={isOpenCollapse}
        toggleCollapse={toggleCollapse}
        handleSubmit={handleSubmit}
        clientTypes={clientTypes}
        singleClientReportEntries={singleClientReportEntries}
        setIsSubmitted={setIsSubmitted}
        organizationInfo={organizationInfo}
      />
      {singleClientReportEntries.length ? (
        <React.Fragment>
          <SingleClientReportEntriesTable
            singleClientReportEntries={singleClientReportEntries}
            organizationInfo={organizationInfo}
          />
          {isOpenCollapse ? (
            <div className="overlay-collapse-open" onClick={toggleCollapse} />
          ) : null}
        </React.Fragment>
      ) : (
        <NoEntriesMessage payload={noEntriesMessage} />
      )}

      {count && singleClientReportEntries.length ? (
        <Row className="pagination-row mt-5 mb-5">
          <Pagination
            count={count}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            rowsPerPage={itemsPerPage}
            page={currentPage - 1}
          />
        </Row>
      ) : null}
      {/* {singleClientReportEntries.length > 0 && count === 1 && (
        <Redirect
          to={`/singleclientreportdetails/${singleClientReportEntries[0].id}`}
        />
      )} */}
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </Container>
  );
};

export default SingleClientReportPage;



// WEBPACK FOOTER //
// ./src/features/reports/pages/single-client-report-page/SingleClientReportPage.jsx